var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { t, Translate } from "../../I18N";
import { Icon } from "../../UI";
import { Warning } from "../../Layout";
import { closePanel, deactivateReference } from "../actions/uiActions";
import Connection from "./Connection";
import { sortTextSelections } from "../utils/sortTextSelections";

import "../scss/viewReferencesPanel.scss";

export class ConnectionsList extends Component {
  static blankStateMessage(title, message) {
    return /*#__PURE__*/(
      _jsx("div", { className: "blank-state" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "sitemap" }), /*#__PURE__*/
      _jsx("h4", {}, void 0, t('System', title)), /*#__PURE__*/
      _jsx("p", {}, void 0, t('System', message))
      ));

  }

  // TODO: remove this method is it's not used anywhere
  // eslint-disable-next-line react/no-unused-class-component-methods
  close() {
    this.props.closePanel();
    this.props.deactivateReference();
  }

  render() {
    const references = this.props.references.
    toJS().
    sort((a, b) => sortTextSelections(a.reference, b.reference));

    if (this.props.loading) {
      return false;
    }

    if (!this.props.references.size && this.props.referencesSection === 'references') {
      return ConnectionsList.blankStateMessage('No References', 'No References description');
    }

    if (!this.props.references.size) {
      return ConnectionsList.blankStateMessage('No Connections', 'No Connections description');
    }

    return /*#__PURE__*/(
      _jsx("div", { className: "item-group" }, void 0,
      references.length > 299 && /*#__PURE__*/
      _jsx(Warning, { inline: true }, void 0, /*#__PURE__*/
      _jsx(Translate, { translationKey: "Text references limit warning" }, void 0, "Text references are temporarily limited to a maximum of 300. We are currently working on a fix for this issue."


      )
      ),

      (() =>
      references.map((reference) => /*#__PURE__*/
      _jsx(Connection, { readOnly: this.props.readOnly, reference: reference }, reference._id)
      ))()
      ));

  }
}










function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closePanel, deactivateReference }, dispatch);
}

export default connect(null, mapDispatchToProps)(ConnectionsList);